export const faqArray = [
  {
    title: 'What does base subscription fee depend on?',
    content: `The parameters that go into calculating your base subscription fee include number of seats,
    number of integrations you need (including unlimited),
    how much connections your average customer creates,
    type and amount of support (including help with implementation and figuring out integration logic). Talk to us to get more detail about the options.`,
  },
  {
    title: 'How is usage fee calculated?',
    content: `
Our customers typically choose per-customer or per-integration usage fee, though there are other options avaialble.
Typically, if you have predictable revenue per customer, the per-customer plan is the best for you.
If you can't associate predictable revenue with each customer or have a lot of customers that use the same integrations,
then per-integration fee is usually a way to go.
`,
  },
  {
    title: 'What is "Customer"?',
    content: `
When your price depends on the number of customers,
each customer could be an individual user or organization depending on how your application works.
We count entities you associate integrations with as "Customers".
You decide to which entity (organization, team, individual) you associate integrations with.
`,
  },
  {
    title: 'What is "Integration"?',
    content: `
Integration is one external app you integrate yours with. For example, "Hubspot" or "JIRA" are integrations.
`,
  },
  {
    title: 'How much support do you provide?',
    content: `
We provide real-time support via shared Slack, MS Teams, or Discord channel.
We effectively become a part of your integration team.
We help with everything from implementing your integration logic and UI to figuring out
how integrations with apps you never used should work.
`,
  },
  {
    title: 'What if I need help with implementation?',
    content: `
We provide recommendations, advice, and code templates for implementing integrations.
If you need actual impelmentation to be done, we have a pool of trusted implementation partners and can manage
your implementation end to end.
`,
  },
  {
    title: 'Can I host Integration.app on my own infrastructure?',
    content: `
Yes, we offer the option to deploy integrations on your premises.
Contact our team for more information on the process and pricing
options.
`,
  },
  {
    title: "I need an integration you don't support yet",
    content: `
Besdies offering a powerful connector builder tool, we have a pool of
implementation partners who can build a new connector for you for a small fee ($300-$1000, depending on complexity).
`,
  },
]
